export function x(d) {
  return d[0];
}

export function y(d) {
  return d[1];
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-voronoi/src/point.js
// module id = ../../../../d3-voronoi/src/point.js
// module chunks = 4